import { createStoreModule } from '../utils';
import { createCookie, readCookie } from '@/utils/cookie';

const COOKIE_NAME = 'cookieconsent_status';
const COOKIE_EXPIRY_DAYS = 365;

function migrateFromLocalStorage() {
  const hasConsent = localStorage.getItem('hasConsent');
  console.log('Migrating consent from localStorage:', hasConsent);
  if (hasConsent !== null) {
    const granted = hasConsent === 'true';
    createCookie(COOKIE_NAME, granted ? '1' : '0', COOKIE_EXPIRY_DAYS);

    localStorage.removeItem('hasConsent');
    localStorage.removeItem('ad_storage');
    localStorage.removeItem('analytics_storage');
    localStorage.removeItem('ad_user_data');
    localStorage.removeItem('ad_personalization');

    return granted;
  }
  return null;
}

function getInitialState() {
  const cookieValue = readCookie(COOKIE_NAME);

  // Cookie exists: "1" = granted, "0" = denied
  if (cookieValue === '1' || cookieValue === '0') {
    const granted = cookieValue === '1';
    const consentValue = granted ? 'granted' : 'denied';
    return {
      adStorageConsent: consentValue,
      analyticsStorageConsent: consentValue,
      adUserDataConsent: consentValue,
      adPersonalizationConsent: consentValue,
      hasConsent: granted,
      consentClosed: false
    };
  }

  // Try migrating from localStorage
  const migrated = migrateFromLocalStorage();
  if (migrated !== null) {
    const consentValue = migrated ? 'granted' : 'denied';
    return {
      adStorageConsent: consentValue,
      analyticsStorageConsent: consentValue,
      adUserDataConsent: consentValue,
      adPersonalizationConsent: consentValue,
      hasConsent: migrated,
      consentClosed: false
    };
  }

  // No consent data found
  return {
    adStorageConsent: 'denied',
    analyticsStorageConsent: 'denied',
    adUserDataConsent: 'denied',
    adPersonalizationConsent: 'denied',
    hasConsent: null,
    consentClosed: false
  };
}

export default createStoreModule({
  name: 'consent',
  modelName: 'consent',
  state: getInitialState(),
  mutations: {
    setConsentData(state, granted) {
      const consentValue = granted ? 'granted' : 'denied';
      state.hasConsent = granted;
      state.adStorageConsent = consentValue;
      state.analyticsStorageConsent = consentValue;
      state.adUserDataConsent = consentValue;
      state.adPersonalizationConsent = consentValue;
      state.consentClosed = true;

      createCookie(COOKIE_NAME, granted ? '1' : '0', COOKIE_EXPIRY_DAYS);
    }
  },
  actions: {
    grantConsent({ commit }) {
      commit('setConsentData', true);
    },
    denyConsent({ commit }) {
      commit('setConsentData', false);
    }
  },
  getters: {
    consentData: (state) => ({
      ad_storage: state.hasConsent ? state.adStorageConsent : 'denied',
      analytics_storage: state.hasConsent ? state.analyticsStorageConsent : 'denied',
      ad_user_data: state.hasConsent ? state.adUserDataConsent : 'denied',
      ad_personalization: state.hasConsent ? state.adPersonalizationConsent : 'denied'
    }),
    shouldShowConsent: (state) => {
      return state.hasConsent === null && !state.consentClosed;
    }
  }
});
